import utils from "utils";
import * as config from "./config";
export default class invoiceExceptionListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $state, getOvatAmtService, sweetalert, invoiceOpenService, initSortService, $timeout, $q, resultTipService, batchHandle, getCodeAndNumber, dictService) {
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {},
        };
        function query() {
            // utils.loading('数据加载中...')
            return httpRequest
                .post_pageErrorLog($scope.queryParam)
                .then((res) => {
                    if (res.data.value) {
                        $scope.result = res.data.value || {};
                        $scope.result.list = $scope.result.list || [];
                    }
                })
                .finally(() => {
                    // utils.loaded()
                });
        }
        $scope.dictData = {}
        const codeArr = ['inv_type', 'manage_type', 'invoice_source', 'department_no', 'BELLE_OP_TYPE', 'is_list', 'ovat_tax_rate', 'full_ele_export_status','full_ele_invoice_flag']
        codeArr.forEach((item) => {
            $scope.dictData[item] = []
        })
        dictService.getAndCache(codeArr).then((res) => {
            angular.extend($scope.dictData, res || {})
            httpRequest.get_getBelleRegion().then(res=>{
                $scope.dictData.region_no = res.data.value.map(ele=>{
                    return {
                        enumCode:ele.regionNo,
                        enumName:ele.regionName ,
                    }
                })
            })
            httpRequest.get_getAllTaxBureau($scope.idToken).then(res=>{
                $scope.dictData.taxBureau_id = res.data.value.map(ele=>{
                    return {
                        enumCode:ele.id,
                        enumName:ele.province,
                    }
                })
            })

            $scope.dictData.ukey_id = $scope.userInfo.sysUkeyList.map(ele=>{
                return {
                    enumCode:ele.ukeyId,
                    enumName:ele.ukeyName,
                }
            })
        })
        function init() {
            //查询当前页面在数据库配置，
            //如果存在配置信息
            httpRequest.get_getUserCustomized(config.profileType).then((res) => {
                $scope.profileInfo = JSON.parse(res.data.value);
                if ($scope.profileInfo && $scope.profileInfo.orderMap) {
                    $scope.queryParam.orderMap = {};
                    if ($scope.profileInfo.orderMap.sortKey) {
                        $scope.queryParam.orderMap[$scope.profileInfo.orderMap.sortKey] = $scope.profileInfo.orderMap.sortVal;
                    }
                }
                if ($scope.profileInfo && $scope.profileInfo.orderMap) {
                    $scope.orderMap = $scope.profileInfo.orderMap;
                } else {
                    $scope.orderMap = initSortService("invoiceExceptionOrderMap", true);
                }
                if ($scope.profileInfo && $scope.profileInfo.pageSize) {
                    $scope.queryParam.pageSize = Number($scope.profileInfo.pageSize);
                }
                $scope.handleSearch();
            });
        }
        init();

        $scope.profileConfig = {
            version: config.version,
            table: config.columns,
            queryForm: config.formSchema,
        };
        $scope.profileType = config.profileType;
        $scope.$watch("orderMap", function (n, o) {
            if (n && $scope.profileInfo) {
                $scope.profileInfo.orderMap = $scope.orderMap;
                httpRequest.post_saveUserCustomized({
                    profileInfo: JSON.stringify($scope.profileInfo),
                    profileType: config.profileType,
                });
            }
        });
        $scope.$watch("queryParam.pageSize", function (n, o) {
            if (n && $scope.profileInfo && $scope.profileInfo.pageSize != n) {
                $scope.profileInfo.pageSize = n;
                httpRequest.post_saveUserCustomized({
                    profileInfo: JSON.stringify($scope.profileInfo),
                    profileType: config.profileType,
                });
            }
        });
        $scope.handleSearch = function handleSearch() {
            $scope.queryParam.pageNum = 1;
            query();
        };
        $scope.handlePageChange = function handlePageChange() {
            query();
        };
        $scope.handleReset = function handleReset() {
            config.formSchema.forEach((item) => {
                if (item.type === "date") {
                    $scope.queryParam.param[`${item.name}Max`] = "";
                    $scope.queryParam.param[`${item.name}Min`] = "";
                } else {
                    $scope.queryParam.param[item.name] = "";
                }
            });
        };
        $scope.handleSort = function handleSort() {
            $scope.queryParam.orderMap = {};
            if ($scope.orderMap.sortKey) {
                $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal;
            }
            $scope.handleSearch();
        };
        $scope.selectedRows = [];
        $scope.reTry = function(item){
            let ids = []
            if(item){
                ids = [item.invoiceId]
            }else{
                // if(!$scope.selectedRows.length) return logger.logError('请选择数据')
                ids = $scope.selectedRows.map(ele=>{return ele.invoiceId})
            }
            $scope.queryParam.param.invoiceIds = ids
            utils.loading('请求发送中...')
            httpRequest.post_errorRetry($scope.queryParam.param).then(res=>{
                utils.loaded()
                logger.logSuccess('重新触发数据已提交成功')
                query()
            })
        }
        $scope.export = () => {
            httpRequest.get_exportOpenFailInvoiceToXLS({...$scope.queryParam.param,
                accessToken: localStorage.getItem('id_token')})
        }
        $scope.tableDropdownConfig = [
            {
                label: "重试",
                handler(item) {
                    $scope.reTry(item)
                },
                showWhile(item,hasPermit) {
                    return hasPermit('retry');
                },
            },
            {
                label: "删除",
                handler(item) {
                    $scope.delete([item])
                },
                showWhile(item,hasPermit) {
                    return hasPermit('delete');
                },
            },
        ];
        $scope.$watch('selectedRows.length', () => {
            if (!$scope.selectedRows.length) {
                $scope.queryParam.param.invoiceIdList = []
            }else {
                $scope.queryParam.param.invoiceIdList = $scope.selectedRows.map((ele) => {
                    return ele.invoiceId
                })
            }
        })
        $scope.allEleTemplateExport = () => {
            const exportParam = Object.assign($scope.queryParam.param,{opType:'0',fullEleInvoiceFlag:'1'})
            httpRequest.get_exportFullOpenFailInvoiceToXLS({...exportParam,
                accessToken: localStorage.getItem('id_token')})
        }
            //批量操作
    $scope.batchDropdownConfig = {
        btnText: '批量操作',
        options: [
          {
            text: '批量删除',
            hasPermit: 'batch_delete',
            handler() {
              $scope.delete($scope.selectedRows);
            },
          },
        ],
      };
      $scope.delete = (list)=> {
        const idList = list.map((item)=> item.invoiceId)
        utils.loading('删除中...')
        httpRequest.post_batchDeleteErrorLog(idList).then(res=>{
            utils.loaded()
            logger.logSuccess('删除成功')
            query()
        })
      }
    }
}
invoiceExceptionListCtrl.$inject = ["$scope", "$uibModal", "logger", "httpRequest", "$state", "getOvatAmtService", "sweetalert", "invoiceOpenService", "initSortService", "$timeout", "$q", "resultTipService", "batchHandle", "getCodeAndNumber", "dictService"];



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoiceException/list.js